var _image;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "Vector_Smart_Object",
    "data-name": "Vector Smart Object",
    width: 16,
    height: 10,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAKCAYAAAC9vt6cAAABAklEQVQokY3QQStEURjG8d/MTZHyUSxlYRaMmqhJsROWN/kEuhu7m5W17hLZUZoaKyzGQmyVDzEbKSFdo1MnCXdy6vR23ud5/uec17CVZMVu2EM9lUJWbGMHM/VG+23Q61z/G5BkxRb2vrXm6412f9Dr3P301v4Ir+EwHvdj3Yx1vczTo0pAkhVLOEUdx9iI0gFW8YHlMk/PfgGSrGjiHCPoYKXM0/eohd4J2gi9hTJPL74ASVZM4xJjuMJimaevP143ii5m8YK5Mk9vaklWTKKHCdxG4bliuOPxoik8oRH+GqghfI9WVTisqLWiN2S6AdDHA5plnj5Whb9BgifM6wH9T6+5U9sbGL1HAAAAAElFTkSuQmCC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/Up.d1695c70321c2d888112d9f6aae03912.svg";
export { ForwardRef as ReactComponent };